module.exports = __webpack_public_path__ + "img/ko_iki5.81ada244.jpg";